// NAIZOR — añade el bundle de «Complete your routine» (y el regalo del carrito) sin salir de la página.
// Emite el mismo evento estándar que el botón del tema, así el carrito y el contador se actualizan solos.
// Si algo falla antes de llegar a la tienda, se envía el formulario normal (lleva al carrito).
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

const routes = () => (typeof Theme !== 'undefined' && Theme.routes) || {};
const cartUrl = () => routes().cart_url || '/cart';
const addUrl = () => (routes().cart_add_url || '/cart/add').replace(/\.js$/, '') + '.js';

function cartSectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
}

async function onSubmit(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('nz-up__form')) return;
  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const label = form.querySelector('.nz-up__label');
  const error = form.querySelector('.nz-up__error');
  if (!button || button.getAttribute('aria-busy') === 'true') return;
  button.setAttribute('aria-busy', 'true');
  if (error) {
    error.hidden = true;
    error.textContent = '';
  }

  const data = new FormData(form);
  const ids = cartSectionIds();
  if (ids.length) data.append('sections', ids.join(','));
  const quantity = Number(data.get('quantity')) || 1;
  const deferred = CartLinesUpdateEvent.createPromise();

  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(data.get('id')), quantity }],
      promise: deferred.promise,
    })
  );

  let response;
  try {
    const res = await fetch(addUrl(), {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    response = await res.json();
  } catch (err) {
    deferred.reject(err);
    button.removeAttribute('aria-busy');
    form.submit();
    return;
  }

  const failed = Boolean(response && response.status);
  try {
    const cart = await fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'nz-bundle-upsell',
        itemCount: quantity,
        sections: failed ? undefined : response.sections,
        didError: failed,
      },
    });
  } catch (err) {
    deferred.reject(err);
  }

  if (failed) {
    form.dispatchEvent(
      new CartErrorEvent({
        error: response.message || 'Add to cart failed',
        code: 'INVALID',
        detail: { description: response.description, errors: response.errors },
      })
    );
    if (error) {
      error.textContent = response.description || response.message || '';
      error.hidden = false;
    }
  } else {
    if (label && button.dataset.added) {
      const original = label.textContent;
      label.textContent = button.dataset.added;
      setTimeout(() => {
        label.textContent = original;
      }, 2600);
    }
    // Desde dentro del carrito (botón del regalo) no hace falta abrirlo: ya se está viendo.
    if (!form.closest('cart-items-component')) {
      try {
        const openCart = window.Shopify?.actions?.openCart;
        if (typeof openCart === 'function') openCart.call(window.Shopify.actions);
      } catch (err) {
        console.warn('[nz-bundle-add] openCart', err);
      }
    }
  }
  button.removeAttribute('aria-busy');
}

if (!window.__nzBundleAdd) {
  window.__nzBundleAdd = true;
  document.addEventListener('submit', onSubmit);
}
